import React, { useRef } from 'react';
import { FormattedDate } from 'react-intl';

import useTimer from '@swf/core/hooks/useTimer';

import styles from './MachineDate.scss';

const timeUpdater = (time: number) => time + 1000;

const MachineDate = () => {
  const startTime = useRef(Date.now());
  const date = useTimer({ modifier: timeUpdater, initial: startTime.current });

  return (
    <div className={styles.date}>
      <span className={styles.dateContent} suppressHydrationWarning>
        <FormattedDate
          value={date}
          year="numeric"
          day="2-digit"
          month="2-digit"
          hour="2-digit"
          minute="numeric"
          second="numeric"
        />
      </span>
    </div>
  );
};

export default MachineDate;
